import { Language } from "../enums/language.enum"
import { UserType } from "../enums/user-type.enum"
import { UserAbilities } from "../models/user-abilities.model"
import { User } from "../models/user.model"

export const AUTOMATED_PRISM_USER_ID = 'automated-prism-user-id'

export const AUTOMATED_PRISM_USER: User = {
    id: AUTOMATED_PRISM_USER_ID,
    email: 'system@seljan.com',
    phoneNumber: '',
    firstName: 'system',
    lastName: '',
    imageUrl: '',
    thumbnailImageUrl: '',
    updatedOn: null as unknown as Date,
    createdOn: null as unknown as Date,
    abilities: {} as UserAbilities,
    active: true,
    badgeId: null,
    userType: UserType.EMAIL,
    primaryLanguage: Language.ENGLISH,
    workspaceUserId: '',
}
